(() => {
    const questions = [
      { question: 'What best describes your dog’s personality?', answers: [
        { text: 'Curious. Can be an escape artist', points: { ravenclaw: 3 } },
        { text: 'Unfazed by anything', points: { gryffindor: 3, slytherin: 1 } },
        { text: 'Affectionate and Sweet', points: { hufflepuff: 3 } },
        { text: 'Spoiled. Always gets what they want', points: { slytherin: 3, gryffindor: 1 } }
      ]},
      { question: 'When something new or scary happens, how does your dog react?', answers: [
        { text: 'Looks around and makes sense of it', points: { ravenclaw: 3 } },
        { text: 'Keeps close, guarding while quietly assessing', points: { hufflepuff: 3, gryffindor: 1 } },
        { text: 'Jumps up without hesitation', points: { gryffindor: 3 } },
        { text: 'Looks around and moves to investigate', points: { slytherin: 3, ravenclaw: 1 } }
      ]},
      { question: 'What makes your dog happiest?', answers: [
        { text: 'Getting what they want (treats, toys, attention)', points: { slytherin: 3 } },
        { text: 'Running, playing, and exciting moments', points: { gryffindor: 3 } },
        { text: 'Doing tricks for treats', points: { ravenclaw: 3 } },
        { text: 'Playing with people or other pets', points: { hufflepuff: 3 } }
      ]},
      { question: 'Where does your dog feel most at home?', answers: [
        { text: 'An environment built for running and discovery', points: { ravenclaw: 3 } },
        { text: 'Any place where I am', points: { hufflepuff: 3 } },
        { text: 'A place with a full view of everything going on', points: { slytherin: 3 } },
        { text: 'Anywhere lively and full of play', points: { gryffindor: 3 } }
      ]},
      { question: 'How would other people describe your dog?', answers: [
        { text: 'Calm', points: { hufflepuff: 3 } },
        { text: 'Poised', points: { gryffindor: 3 } },
        { text: 'Smart', points: { ravenclaw: 3 } },
        { text: 'Stubborn', points: { slytherin: 3 } }
      ]},
      { question: 'What does your dog do when other dogs are around?', answers: [
        { text: 'Watches and waits before jumping in to play', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'Stays close and waits for my signal to start playing', points: { hufflepuff: 3 } },
        { text: 'Runs around first and lets dogs chase', points: { gryffindor: 3 } },
        { text: 'Jumps in with the group to play', points: { slytherin: 3, gryffindor: 1 } }
      ]},
      { question: 'What trait is your dog known for?', answers: [
        { text: 'Expressing affection openly. Lots of kisses', points: { hufflepuff: 3 } },
        { text: 'Being smart. Seems like they can tell time', points: { slytherin: 3 } },
        { text: "Sees patterns and understands them fast. Knows when I'm moving toward a treat", points: { ravenclaw: 3 } },
        { text: 'Protects without hesitation. No one will sneak up', points: { gryffindor: 3 } }
      ]},
      { question: 'When your dog is playing, what stands out most?', answers: [
        { text: 'Anticipates what is about to happen and then springs into action', points: { ravenclaw: 3, slytherin: 1 } },
        { text: '100% energy. Go, go, go! Play, play, play!', points: { gryffindor: 3 } },
        { text: 'Always finds a way to get what they want no matter how long it might take', points: { slytherin: 3 } },
        { text: 'Happiest dog in the dog park', points: { hufflepuff: 3 } }
      ]},
      { question: 'What kind of activity would your dog enjoy most?', answers: [
        { text: 'Anything with me: sleep, bathroom, laundry, etc.', points: { hufflepuff: 3 } },
        { text: 'When I bring home a new toy, or anything they think is a new toy', points: { ravenclaw: 3 } },
        { text: 'Running, jumping, and being active... even at 4:30am', points: { gryffindor: 3 } },
        { text: 'Any activity that is rewarded with treats or my attention', points: { slytherin: 3 } }
      ]},
      { question: 'When your dog sees something new (a person, toy, or place), how do they react?', answers: [
        { text: 'Mine! Mine! Mine! Runs in, tail high and ready for action', points: { gryffindor: 3, hufflepuff: 1 } },
        { text: 'Pauses, observes carefully, approaches with curiosity, then pounces', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'Walks up happily, wagging tail, ready to make a new friend... but mainly wants the treat', points: { hufflepuff: 3, gryffindor: 1 } },
        { text: 'Watches carefully, then moves in strategically when it benefits them', points: { slytherin: 3, ravenclaw: 1 } }
      ]},
      { question: 'Which saying fits your dog best?', answers: [
        { text: 'Loves anything new: new toy, new park, new treats', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'Loves playing with their favorite toy that belongs only to them, no other dogs', points: { slytherin: 3 } },
        { text: 'A ride to the dog park is just as much fun as the dog park. Window down please!', points: { gryffindor: 3 } },
        { text: "Loves being there with me no matter what; especially in the bathroom. Sitting. Watching", points: { hufflepuff: 3 } }
      ]},
      { question: 'Which choice sounds most like your dog?', answers: [
        { text: 'Has to be the first one to the toy no matter what. My toy! Give me my toy!', points: { slytherin: 3 } },
        { text: "Jumps in because it might be fun. Doesn't like to sit back.", points: { gryffindor: 3 } },
        { text: "Always curious what's on the other side of the fence. Best fence protector ever!", points: { ravenclaw: 3 } },
        { text: "I'm the center of their universe. That deserves another treat, right?", points: { hufflepuff: 3 } }
      ]}
    ];

    const houseResults = {
      gryffindor: {
        name: 'Gryffindor',
        description: 'Your dog is brave, bold, and full of energy. They are always ready for action—whether it is chasing a ball, exploring something new, or protecting their favorite human. They do not back down easily and love being right in the middle of the excitement.',
        secondary: 'Fearless, Energetic, and Adventurous',
        resultTitle: 'Your dog is a Gryffindor! The fearless adventurer.',
        bundleHeading: 'Gryffindor Dog Picks',
        bundleIntro: 'Lean into the brave-and-bold energy with playful picks made for action, color, and house pride.',
        bundleItems: [
          { title: 'Gryffindor dog bandanas', description: 'A bold house look for walks, photos, and Hogwarts-level flair.', url: '/search?q=gryffindor+dog+bandana' },
          { title: 'Gryffindor toys', description: 'Fun picks for energetic play, fetch, and fearless zoomies.', url: '/search?q=gryffindor+dog+toy' },
          { title: 'Gryffindor pet accessories', description: 'Collars, bowls, and extras for a brave best friend.', url: '/search?q=gryffindor+dog' }
        ]
      },
      ravenclaw: {
        name: 'Ravenclaw',
        description: 'Your dog is smart, curious, and always thinking. They love learning new tricks, figuring things out, and watching everything around them. You might catch them tilting their head like they are solving a mystery—they probably are.',
        secondary: 'Smart, Curious, and Observant',
        resultTitle: 'Your dog is a Ravenclaw! The clever thinker.',
        bundleHeading: 'Ravenclaw Dog Picks',
        bundleIntro: 'Great for bright pups who love puzzles, learning, and watching the whole room like tiny professors.',
        bundleItems: [
          { title: 'Ravenclaw dog bandanas', description: 'A smart-looking house style for your curious companion.', url: '/search?q=ravenclaw+dog+bandana' },
          { title: 'Puzzle and training toys', description: 'Perfect for dogs that like to figure things out.', url: '/search?q=dog+puzzle+toy' },
          { title: 'Ravenclaw pet accessories', description: 'Clever house-themed finds for observant pups.', url: '/search?q=ravenclaw+dog' }
        ]
      },
      hufflepuff: {
        name: 'Hufflepuff',
        description: 'Your dog is loving, loyal, and everyone’s best friend. They just want to be close to their people, give affection, and make others happy. They are the kind of dog who greets everyone with a wagging tail and never holds a grudge.',
        secondary: 'Loyal, Sweet, and Friendly',
        resultTitle: 'Your dog is a Hufflepuff! The loyal sweetheart.',
        bundleHeading: 'Hufflepuff Dog Picks',
        bundleIntro: 'Perfect for affectionate pups who love comfort, cuddles, and being everyone’s favorite.',
        bundleItems: [
          { title: 'Hufflepuff dog bandanas', description: 'A warm and cheerful house look for your loyal companion.', url: '/search?q=hufflepuff+dog+bandana' },
          { title: 'Cozy dog accessories', description: 'Comfort-focused picks for sweet and snuggly pets.', url: '/search?q=cozy+dog+accessories' },
          { title: 'Hufflepuff pet gifts', description: 'Soft, friendly, and giftable finds full of house pride.', url: '/search?q=hufflepuff+dog' }
        ]
      },
      slytherin: {
        name: 'Slytherin',
        description: 'Your dog is confident, clever, and knows exactly what they want. Whether it is getting the best spot on the couch or finding a way to sneak an extra treat, they always seem one step ahead. They play smart—and usually win.',
        secondary: 'Clever, Confident, and Determined',
        resultTitle: 'Your dog is a Slytherin! The clever charmer.',
        bundleHeading: 'Slytherin Dog Picks',
        bundleIntro: 'Ideal for pups with confidence, charm, and a talent for getting exactly what they want.',
        bundleItems: [
          { title: 'Slytherin dog bandanas', description: 'A sharp house look for stylish and strong-willed pups.', url: '/search?q=slytherin+dog+bandana' },
          { title: 'Treat-ready accessories', description: 'Perfect for dogs who know how to work the room.', url: '/search?q=dog+treat+accessories' },
          { title: 'Slytherin pet accessories', description: 'Green-and-silver style for the most determined companion.', url: '/search?q=slytherin+dog' }
        ]
      }
    };

    const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value || '');
    const sanitizeTagPart = (value) => (value || '').toString().trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

    function initSortingSection(section) {
      if (!section || section.dataset.sortingInitialized === 'true') return;
      section.dataset.sortingInitialized = 'true';

      const configScript = section.querySelector('[data-sorting-config]');
      if (!configScript) return;

      let config = { collectionUrls: {}, resultImageUrls: {} };
      try {
        config = JSON.parse(configScript.textContent);
      } catch (e) {
        console.error('Sorting Hat config parse error', e);
      }

      const stepEls = {
        age: section.querySelector('[data-step="age"]'),
        under13: section.querySelector('[data-step="under13"]'),
        contact: section.querySelector('[data-step="contact"]'),
        quiz: section.querySelector('[data-step="quiz"]'),
        result: section.querySelector('[data-step="result"]')
      };

      const els = {
        firstName: section.querySelector('[data-input-first-name]'),
        email: section.querySelector('[data-input-email]'),
        ageRange: section.querySelector('[data-input-age-range]'),
        gender: section.querySelector('[data-input-gender]'),
        consent: section.querySelector('[data-input-consent]'),
        contactError: section.querySelector('[data-contact-error]'),
        progress: section.querySelector('[data-progress]'),
        question: section.querySelector('[data-question]'),
        answers: section.querySelector('[data-answers]'),
        next: section.querySelector('[data-next-question]'),
        resultCard: section.querySelector('[data-result-card]'),
        resultGreeting: section.querySelector('[data-result-greeting]'),
        resultHouse: section.querySelector('[data-result-house]'),
        resultAnimal: section.querySelector('[data-result-animal]'),
        resultImageWrap: section.querySelector('[data-result-image-wrap]'),
        resultImage: section.querySelector('[data-result-image]'),
        resultSecondary: section.querySelector('[data-result-secondary]'),
        resultDescription: section.querySelector('[data-result-description]'),
        resultFriscoNote: section.querySelector('[data-result-frisco-note]'),
        shopLink: section.querySelector('[data-shop-link]'),
        bundleGrid: section.querySelector('[data-bundle-grid]'),
        shareFacebook: section.querySelector('[data-share-facebook]'),
        shareInstagram: section.querySelector('[data-share-instagram]'),
        downloadImage: section.querySelector('[data-download-image]'),
        copyCaption: section.querySelector('[data-copy-caption]'),
        shareModal: section.querySelector('[data-share-modal]'),
        shareModalImage: section.querySelector('[data-share-modal-image]'),
        shareModalCaption: section.querySelector('[data-share-modal-caption]'),
        shareModalDownload: section.querySelector('[data-share-modal-download]'),
        shareModalCopy: section.querySelector('[data-share-modal-copy]'),
        shareClose: section.querySelectorAll('[data-share-close]'),
        emailResultWrap: section.querySelector('[data-email-result-wrap]'),
        emailFirstName: section.querySelector('[data-email-first-name]'),
        emailAddress: section.querySelector('[data-email-address]'),
        emailTags: section.querySelector('[data-email-tags]'),
        emailPreview: section.querySelector('[data-email-preview]')
      };

      const resetScores = () => ({
        gryffindor: 0,
        ravenclaw: 0,
        hufflepuff: 0,
        slytherin: 0
      });

      const state = {
        collectData: false,
        currentQuestionIndex: 0,
        selectedAnswerIndex: null,
        scores: resetScores()
      };

      const shareState = {
        url: '',
        caption: '',
        imageUrl: '',
        filename: 'sorting-hat-dog-result.jpg'
      };

      const showStep = (stepKey) => {
        Object.entries(stepEls).forEach(([key, el]) => {
          if (!el) return;
          el.classList.toggle('mh-hidden', key !== stepKey);
        });
      };

      const restart = () => {
        state.collectData = false;
        state.currentQuestionIndex = 0;
        state.selectedAnswerIndex = null;
        state.scores = resetScores();

        if (els.contactError) {
          els.contactError.innerHTML = '';
          els.contactError.classList.add('mh-hidden');
        }

        if (els.firstName) els.firstName.value = '';
        if (els.email) els.email.value = '';
        if (els.ageRange) els.ageRange.value = '';
        if (els.gender) els.gender.value = '';
        if (els.consent) els.consent.checked = false;

        if (els.progress) els.progress.textContent = '';
        if (els.question) els.question.textContent = '';
        if (els.answers) els.answers.innerHTML = '';
        if (els.next) els.next.classList.add('mh-hidden');

        if (els.resultGreeting) els.resultGreeting.textContent = '';
        if (els.resultHouse) els.resultHouse.textContent = '';
        if (els.resultAnimal) els.resultAnimal.textContent = '';
        if (els.resultSecondary) els.resultSecondary.textContent = '';
        if (els.resultDescription) els.resultDescription.textContent = '';
        if (els.resultFriscoNote) els.resultFriscoNote.innerHTML = '';

        if (els.resultCard) {
          els.resultCard.classList.remove('is-gryffindor', 'is-ravenclaw', 'is-hufflepuff', 'is-slytherin');
        }

        if (els.resultImage) {
          els.resultImage.src = '';
          els.resultImage.alt = '';
          els.resultImage.classList.add('mh-hidden');
        }
        if (els.resultImageWrap) els.resultImageWrap.classList.add('mh-hidden');
        if (els.shopLink) els.shopLink.href = '#';
        if (els.bundleGrid) els.bundleGrid.innerHTML = '';

        if (els.emailResultWrap) els.emailResultWrap.classList.add('mh-hidden');

        showStep('age');
      };

      const renderQuestion = () => {
        const q = questions[state.currentQuestionIndex];
        state.selectedAnswerIndex = null;

        if (els.progress) {
          els.progress.textContent = `Question ${state.currentQuestionIndex + 1} of ${questions.length}`;
        }

        if (els.question) {
          els.question.textContent = q.question;
        }

        if (!els.answers) return;

        els.answers.innerHTML = '';
        if (els.next) els.next.classList.add('mh-hidden');

        q.answers.forEach((answer, index) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mh-answer';
          btn.textContent = answer.text;

          btn.addEventListener('click', () => {
            state.selectedAnswerIndex = index;
            [...els.answers.querySelectorAll('.mh-answer')].forEach((node, i) => {
              node.classList.toggle('is-selected', i === index);
            });
            if (els.next) els.next.classList.remove('mh-hidden');
          });

          els.answers.appendChild(btn);
        });
      };

      const startQuiz = (collect) => {
        state.collectData = collect;
        state.currentQuestionIndex = 0;
        state.selectedAnswerIndex = null;
        state.scores = resetScores();
        showStep('quiz');
        renderQuestion();
      };

      const nextQuestion = () => {
        if (state.selectedAnswerIndex === null) return;

        const selected = questions[state.currentQuestionIndex].answers[state.selectedAnswerIndex];
        Object.entries(selected.points).forEach(([house, points]) => {
          state.scores[house] += points;
        });

        state.currentQuestionIndex += 1;

        if (state.currentQuestionIndex < questions.length) {
          renderQuestion();
        } else {
          showResult();
        }
      };


      const buildResultLinks = (primaryKey, primaryName) => {
        const accentClass = `mh-result-link-card--${primaryKey}`;
        const primaryUrl = (config.collectionUrls && config.collectionUrls[primaryKey]) || '#';
        const allAnimalUrl = '/search?q=' + encodeURIComponent('dog OR dog-neutral');
        const allPetUrl = '/search?q=' + encodeURIComponent('dog OR dog-neutral OR cat OR cat-neutral');
        const mixedUrl = '/search?q=' + encodeURIComponent(`${primaryKey}-dog OR ${primaryKey}-cat`);
        const cards = [
          { title: `${primaryName} Dog Accessories`, url: primaryUrl },
          { title: `${primaryName} Dog & Cat Accessories`, url: mixedUrl },
          { title: `All Dog Accessories`, url: allAnimalUrl },
          { title: 'All Pet Accessories', url: allPetUrl }
        ];
        return cards.map((item) => `
          <a class="mh-result-link-card ${accentClass}" href="${item.url}">
            <span class="mh-result-link-card-kicker">Shop now</span>
            <span class="mh-result-link-card-title">${item.title}</span>
            <span class="mh-result-link-card-arrow" aria-hidden="true">→</span>
          </a>
        `).join('');
      };

      const buildShareUrl = (primaryKey) => {
        const baseUrl = `${window.location.origin}${window.location.pathname}`;
        return `${baseUrl}?share_result=${encodeURIComponent(`${primaryKey}-dog`)}`;
      };

      const buildShareCaption = (primary, secondary) => {
        const shareUrl = shareState.url || buildShareUrl(primary.key || '');
        const secondaryLine = secondary ? ` Secondary match: ${secondary.name}.` : '';
        return `My dog was sorted into ${primary.name} at The Muggle Hut!${secondaryLine}\nSee the result: ${shareUrl}\n#TheMuggleHut #${primary.name.replace(/\s+/g, '')} #HarryPotterPets #DogQuiz`;
      };

      const copyShareCaption = async () => {
        if (!shareState.caption) return;
        try {
          await navigator.clipboard.writeText(shareState.caption);
        } catch (error) {
          const fallback = document.createElement('textarea');
          fallback.value = shareState.caption;
          document.body.appendChild(fallback);
          fallback.select();
          document.execCommand('copy');
          fallback.remove();
        }
      };

      const downloadShareImage = () => {
        if (!shareState.imageUrl) return;
        const link = document.createElement('a');
        link.href = shareState.imageUrl;
        link.download = shareState.filename;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
      };

      const openShareModal = () => {
        if (!els.shareModal) return;
        if (els.shareModalImage) {
          els.shareModalImage.src = shareState.imageUrl || '';
          els.shareModalImage.alt = shareState.filename.replace(/[-_]/g, ' ');
        }
        if (els.shareModalCaption) {
          els.shareModalCaption.value = shareState.caption || '';
        }
        els.shareModal.classList.remove('mh-hidden');
        document.body.classList.add('mh-share-modal-open');
      };

      const closeShareModal = () => {
        if (!els.shareModal) return;
        els.shareModal.classList.add('mh-hidden');
        document.body.classList.remove('mh-share-modal-open');
      };

      const updateShareState = (primaryKey, primary, secondary = null) => {
        shareState.url = buildShareUrl(primaryKey);
        shareState.imageUrl = (config.resultImageUrls && config.resultImageUrls[primaryKey]) || '';
        shareState.filename = `${primaryKey}-dog-sorting-hat.jpg`;
        shareState.caption = buildShareCaption({ ...primary, key: primaryKey }, secondary);
      };

      const renderResultState = (primaryKey, secondaryKey = null, options = { shared: false }) => {
        showStep('result');

        const primary = houseResults[primaryKey];
        const secondary = secondaryKey ? houseResults[secondaryKey] : null;
        if (!primary) return;

        if (els.resultGreeting) {
          els.resultGreeting.textContent = 'The Sorting Hat has spoken:';
        }

        if (els.resultHouse) els.resultHouse.textContent = primary.name;
        if (els.resultAnimal) els.resultAnimal.textContent = 'Dog';
        if (els.resultSecondary) {
          if (secondary) {
            els.resultSecondary.innerHTML = `<span class="mh-result-secondary-primary">${primary.secondary}.</span><span class="mh-result-secondary-match">Your secondary match is ${secondary.name}.</span>`;
          } else {
            els.resultSecondary.innerHTML = `<span class="mh-result-secondary-primary">${primary.secondary}.</span>`;
          }
        }
        if (els.resultDescription) els.resultDescription.textContent = primary.description;
        if (els.shopLink) els.shopLink.href = (config.collectionUrls && config.collectionUrls[primaryKey]) || '#';

        /* Frisco pickup note preserved for future store relaunch.
        if (els.resultFriscoNote) {
          els.resultFriscoNote.innerHTML = `📍 <strong>${primary.name}</strong> picks for dogs can be ordered online or picked up locally in Frisco. <a class="mh-frisco-store-link" href="/pages/frisco-harry-potter-store">Visit our Frisco store page</a>.`;
        }
        */

        if (els.bundleGrid) {
          els.bundleGrid.innerHTML = buildResultLinks(primaryKey, primary.name);
        }

        if (els.resultCard) {
          els.resultCard.classList.remove('is-gryffindor', 'is-ravenclaw', 'is-hufflepuff', 'is-slytherin');
          els.resultCard.classList.add(`is-${primaryKey}`);
        }

        if (els.resultImage && config.resultImageUrls && config.resultImageUrls[primaryKey]) {
          els.resultImage.src = config.resultImageUrls[primaryKey];
          els.resultImage.alt = `${primary.name} Dog`;
          els.resultImage.classList.remove('mh-hidden');
          els.resultImageWrap?.classList.remove('mh-hidden');
        } else {
          els.resultImage?.classList.add('mh-hidden');
          els.resultImageWrap?.classList.add('mh-hidden');
        }

        updateShareState(primaryKey, primary, secondary);

        if (state.collectData && els.emailResultWrap && !options.shared) {
          const email = (els.email && els.email.value ? els.email.value.trim() : '');
          const ageRange = (els.ageRange && els.ageRange.value ? els.ageRange.value : '');
          const gender = (els.gender && els.gender.value ? els.gender.value : '');
          const tags = ['sorting-hat', `house-${primaryKey}`];
          if (secondaryKey) tags.push(`secondary-${secondaryKey}`);

          if (ageRange) tags.push(`age-${sanitizeTagPart(ageRange)}`);
          if (gender) tags.push(`gender-${sanitizeTagPart(gender)}`);

          if (els.emailTags) els.emailTags.value = tags.join(',');
          if (els.emailFirstName) els.emailFirstName.value = (els.firstName?.value || '').trim();
          if (els.emailAddress) els.emailAddress.value = email;
          if (els.emailPreview) els.emailPreview.textContent = email || 'your email address';

          els.emailResultWrap.classList.remove('mh-hidden');
        } else if (els.emailResultWrap) {
          els.emailResultWrap.classList.add('mh-hidden');
        }
      };

      const showResult = () => {
        const ranked = Object.keys(state.scores).sort((a, b) => state.scores[b] - state.scores[a]);
        renderResultState(ranked[0], ranked[1]);
      };

      const shareParams = new URLSearchParams(window.location.search);
      const sharedResultValue = (shareParams.get('share_result') || '').toLowerCase();
      const showSharedResultIfPresent = () => {
        const pieces = sharedResultValue.split('-');
        if (pieces.length !== 2) return false;
        const [houseKey, animalKey] = pieces;
        if (animalKey !== 'dog' || !houseResults[houseKey]) return false;
        state.collectData = false;
        renderResultState(houseKey, null, { shared: true });
        return true;
      };
      section.querySelectorAll('[data-age-gate]').forEach((btn) => {
        btn.addEventListener('click', () => showStep(btn.dataset.ageGate === 'yes' ? 'contact' : 'under13'));
      });

      section.querySelector('[data-start-under13]')?.addEventListener('click', () => startQuiz(false));

      section.querySelector('[data-begin-quiz]')?.addEventListener('click', () => {
        const errors = [];
        const firstName = els.firstName?.value.trim() || '';
        const email = els.email?.value.trim() || '';
        const consent = !!els.consent?.checked;

        if (!firstName) errors.push('Please enter your first name.');
        if (!email) errors.push('Please enter your email address.');
        else if (!validateEmail(email)) errors.push('Please enter a valid email address.');
        if (!consent) errors.push('Please check the consent box to continue.');

        if (errors.length) {
          if (els.contactError) {
            els.contactError.innerHTML = errors.join('<br>');
            els.contactError.classList.remove('mh-hidden');
          }
          return;
        }

        if (els.contactError) els.contactError.classList.add('mh-hidden');
        startQuiz(true);
      });

      section.querySelectorAll('[data-restart]').forEach((btn) => btn.addEventListener('click', () => {
        const cleanUrl = `${window.location.origin}${window.location.pathname}`;
        window.history.replaceState({}, '', cleanUrl);
        closeShareModal();
        restart();
      }));
      els.next?.addEventListener('click', nextQuestion);

      els.shareFacebook?.addEventListener('click', () => {
        if (!shareState.url) return;
        const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareState.url)}`;
        window.open(facebookShareUrl, '_blank', 'noopener,noreferrer,width=626,height=436');
      });
      els.shareInstagram?.addEventListener('click', openShareModal);
      els.downloadImage?.addEventListener('click', downloadShareImage);
      els.copyCaption?.addEventListener('click', copyShareCaption);
      els.shareModalDownload?.addEventListener('click', downloadShareImage);
      els.shareModalCopy?.addEventListener('click', copyShareCaption);
      els.shareClose?.forEach((btn) => btn.addEventListener('click', closeShareModal));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && els.shareModal && !els.shareModal.classList.contains('mh-hidden')) {
          closeShareModal();
        }
      });

      if (!showSharedResultIfPresent()) {
        restart();
      }
    }

    function initAllSortingSections() {
      document.querySelectorAll('.mh-sorting-section').forEach(initSortingSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllSortingSections);
    } else {
      initAllSortingSections();
    }
    window.addEventListener('load', initAllSortingSections);

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (!target) return;
      target.querySelectorAll('.mh-sorting-section').forEach(initSortingSection);
      if (target.matches && target.matches('.mh-sorting-section')) initSortingSection(target);
    });
  })();
